import PropTypes from 'prop-types';
import { useSubscription } from '@apollo/client';
import { gql } from '@apollo/client';
import React from 'react';

const USER_LOGGED_IN_SUBSCRIPTION = gql`
  subscription userLoggedIn {
    userLoggedIn {
      userId
      userName
    }
  }
`;

const LogoutProvider = ({ children, userManager }) => {
  useSubscription(USER_LOGGED_IN_SUBSCRIPTION, {
    onSubscriptionData: ({
      subscriptionData: {
        data: { userLoggedIn }
      }
    }) => {
      console.log(
        'Identity server security stamp changed for ' +
          userLoggedIn.userName +
          '  Probably the user logged in on another device. Logging out'
      );
      userManager.signoutRedirect();
    }
  });

  return <>{children}</>;
};

LogoutProvider.propTypes = {
  userManager: PropTypes.object.isRequired,
  children: PropTypes.node
};

export default LogoutProvider;
